<template>
  <div>
    <div
      v-if="text"
      class="chat-message-container"
      :class="message.sender_type !== 'self' ? 'left' : 'right'"
      v-show="message.content.type !== 'not_show'"
    >
      <div v-if="$store.state.config.storeId == 46 && message.sender_type !== 'self'" class="image-cropper" style="width: 42px; height: 42px; position: absolute; left: -6px; bottom: 16px; overflow: hidden; border-radius: 50%; box-shadow: none!important; border: solid rgb(0 0 0 / 14%) 1px; background-color: white;">
        <span
          v-if="message.video_chat"
          :class="
            message.sender_type !== 'self'
              ? 'chat-message-container-badge-left'
              : 'chat-message-container-badge-right'
          "
        >
          <i class="material-icons">
            voice_chat
          </i>
        </span>
        <img
          class="chat-avatar-noo"
          style="display: inline; margin: 0 auto; height: 63%; width: auto; padding-top: 42%; padding-left: 12%;"
          :src="message.sender_type == 'bot' ? this.bot_avatar : (this.admin_avatar || this.bot_avatar)"
          alt="Bot Avatar"
        />
      </div>
      <div v-if="$store.state.config.storeId == 49 && message.sender_type !== 'self'" class="image-cropper"
           :style="{
             width: '42px',
             height: '42px',
             position: 'absolute',
             left: '-6px',
             bottom: '16px',
             overflow: 'hidden',
             borderRadius: '50%',
             boxShadow: 'none!important',
             border: 'solid 1px rgba(0, 0, 0, 0.14)',
             backgroundColor: message.sender_type === 'bot' ? 'black' : ''}"
      >
        <img
          class="chat-avatar-cleed"
          :style="message.sender_type == 'bot' ? 'display: inline; margin: 0 auto; height: 77%; width: auto; padding-top: 21%; padding-left: 15%; background-color: black;'
            : 'position: absolute;top: 50% !important; left: 50%; transform: translate(-50%, -50%); padding:0 !important; height: 69% !important'"
          :src="message.sender_type == 'bot' ? this.bot_avatar : (this.admin_avatar || this.bot_avatar)"
          alt="Bot Avatar"
        />
      </div>
      <img
        v-if="message.sender_type !== 'self' && $store.state.config.storeId == 20"
        class="chat-avatar chat-avatar-manfield"
        :src="message.sender_type == 'bot' ? this.bot_avatar : (this.admin_avatar || this.bot_avatar)"
        alt="Bot Avatar"
      />
      <img
        v-if="message.sender_type !== 'self' && ($store.state.config.storeId == 33 || $store.state.config.storeId == 37)"
        class="chat-avatar"
        :src="message.sender_type == 'bot' ? this.bot_avatar : (this.admin_avatar || this.bot_avatar)"
        alt="Bot Avatar"
        style="left: -6px;"
      />
      <img
        v-if="message.sender_type !== 'self' && $store.state.config.storeId != 49 && $store.state.config.storeId != 46 && $store.state.config.storeId != 20 && $store.state.config.storeId != 33 && $store.state.config.storeId != 37"
        class="chat-avatar"
        :src="message.sender_type == 'bot' ? this.bot_avatar : (this.admin_avatar || this.bot_avatar)"
        alt="Bot Avatar"
      />
      <AudioPlay :text="cleanText" :sender_type="message.sender_type" :index="mkey" />
      <div class="chat-message">
        <typing-indicator v-if="message.typing_indicator" />
        <div v-if="!message.typing_indicator">
          <span style="overflow-wrap: break-word;" v-html="XssClean(text)" />
          <div v-if="message.content.ai_generated" class="cld_chat_rating">
            <div class="cld_chat_rating_card">
              <div class="like grow" @click="ratingLike()">
                <span class="material-icons-outlined openai-icon">thumb_up</span>
              </div>
        
              <div class="dislike grow" @click="ratingDislike()">
                <span class="material-icons-outlined openai-icon">thumb_down</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-message-time-container">
        <relative-time :message="message" />
      </div>
    </div>

    <div v-if="$store.state.config.storeId == 49 && $store.state.config.appIsVisible === false && this.$store.state.user.messages[this.mkey] && this.$store.state.user.messages[this.mkey].content.message == 'chat.callback'" class="chat-message-container right">
      <div class="chat-message message-checker">
        <message-checker></message-checker>
      </div>
    </div>

    <transition v-if="text" name="bounce">
      <div v-if="!message.typing_indicator" class="chat-widget-container">
        <my-carousel
          v-if="message.content && message.content.carousel"
          :carousel="message.content.carousel"
        ></my-carousel>

        <div
          v-if="message.content && message.content.attachment"
          class="chat-message"
          style="max-width: 100% !important; overflow: hidden"
        >
          <my-carousel
            :carousel="message.content.attachment"
            attachment
          >
          </my-carousel>
        </div>

        <!--<div class="chat-message" style="max-width: 100% !important" v-if="message.content.step == 'box_email' ||
        (message.sender_type == 'bot' && this.message.content && (this.$store.state.config.i18n.fr.chat.welcome || this.$store.state.config.i18n.en.chat.welcome) &&
        (this.message.content == this.$store.state.config.i18n.fr.chat.welcome || this.$store.state.config.i18n.en.chat.welcome) &&
        message.content.step != 'start' && message.content.condition != 'Retour à l\'accueil' && this.message.content.message != 'chat.first')"> -->

        <div v-else-if="((this.$store.state.user.messages[this.mkey] && this.$store.state.user.messages[this.mkey].content.message == 'chat.not_reactive') || (this.$store.state.user.messages[this.mkey] && ['chat.not_here','chat.not_here_thumb_down'].includes(this.$store.state.user.messages[this.mkey].content.message))) && message.sender_type == 'bot'" class="chat-message" style="max-width: 100% !important">
          <BoxEmailMessage 
            :ask_email="true" 
            :skip_to='$store.state.user.messages[mkey].content.skip_to || null'
          />
          <!-- ask_email can be true or false for BoxEmailMessage to display based on the email if already set -->
        </div>
        <div v-else-if="(this.$store.state.config.storeId == 20 || this.$store.state.config.storeId == 33 || this.$store.state.config.storeId == 49 || this.$store.state.config.storeId == 51 || this.$store.state.config.storeId == 52) && message.sender_type == 'bot' && message.content.message == 'message.recontact'" class="chat-message" style="max-width: 100% !important">
          <BoxEmailMessage 
            :ask_email="true" 
            :skip_to='$store.state.user.messages[mkey].content.skip_to || null'
          />
          <!-- ask_email can be true or false for BoxEmailMessage to display based on the email if already set -->
        </div>
        <div v-else-if="(this.$store.state.config.storeId == 53 || this.$store.state.config.storeId == 49) && message.sender_type == 'bot' && (message.content.message == 'message.recontact' || message.content.message == 'message.recontact2')" class="chat-message" style="max-width: 100% !important; margin-top: 15px">
          <BoxEmailFirstname />
          <!-- ask_email can be true or false for BoxEmailMessage to display based on the email if already set -->
        </div>
        <div v-else-if="(this.$store.state.config.chat_config.chat_state.state == 'no-active' && this.$store.state.navigation.mode == 'chat' && this.$store.state.user.style_profile == false && ['chat.not_here','chat.not_here_thumb_down'].includes(this.$store.state.user.messages[this.mkey].content)) && this.$store.state.user.messages[this.mkey].sender_type == 'bot'" class="chat-message" style="max-width: 100% !important">          
          <BoxEmailMessage 
            :ask_email="true" 
            :skip_to='$store.state.user.messages[mkey].content.skip_to || null'
          />
          <!--Show the box email message again when refresh if last message was chat.not_here and still box no_active-->
        </div>
        <div v-else-if="this.box_search === true && message.sender_type == 'bot'" class="chat-message" style="max-width: 100% !important">
          <BoxSearch />
        </div>
        <div v-else-if="this.$store.state.user.messages[this.mkey].content.content && this.$store.state.user.messages[this.mkey].content.content.type === 'rating'" class="chat-message" style="max-width: 100% !important; margin-bottom: 30px;">
          <Rating :grade="0" :disabled="false" />
        </div>
        <div v-else-if="this.$store.state.user.messages[this.mkey] && this.$store.state.user.messages[this.mkey].content == 'whatsapp_messaging.init_store_conversation'" style="max-width: 100% !important; display: flex; justify-content:center;">
          <accordion />
        </div>
        <div v-else-if="(this.$store.state.user.messages[this.mkey] && this.$store.state.user.messages[this.mkey].content == 'whatsapp_messaging.add_phone' && !this.$store.state.user.phone) || (this.$store.state.user.messages[this.mkey] && this.$store.state.user.messages[this.mkey].content.message == 'whatsapp_messaging.add_phone' && !this.$store.state.user.phone)" class="chat-message" style="max-width: 100% !important">
          <box-phone></box-phone>
        </div>
        <AgentAssign v-else-if="message.content && message.content.type == 'agent_assign'" :name="message.content.agent"></AgentAssign>
        <chat-form
          v-else-if="message.content && message.content.form && (this.$store.state.config.storeId == 33 || this.$store.state.config.storeId == 50 || this.$store.state.config.storeId == 43 || this.$store.state.config.storeId == 49 || this.$store.state.config.storeId == 53)"
          :form="message.content.form"
          :fid="'chat-form-' + mkey"
        ></chat-form>
        <grid
          v-else-if="message.content && message.content.grid"
          :grid="message.content.grid"
        ></grid>
        <brands
          v-else-if="message.content && message.content.brands"
          :brands="message.content.brands"
        ></brands>
        <look
          v-else-if="message.content && message.content.look"
          :look="message.content.look"
        ></look>
        <selection v-else-if="message.content && message.content.selection" 
                   :selection="message.content.selection"
                   :disabled="$store.state.user.messages.length -1 !== mkey"
        >
        </selection>
        <QcmQuestions v-else-if="message.content && message.content.questions" 
                   :questions="message.content.questions" 
                   :step_value="message.content.step_value" 
                   :live_coach="message.content.live_coach"
                   :disabled="$store.state.user.messages.length -1 !== mkey"
        >
        </QcmQuestions>
        <product-card
          v-else-if="false"
          :product="message.content.product_card"
          :alone="message.content.alone"
          :like-dislike="false"
        ></product-card>
        <multi 
          v-else-if="message.content && message.content.multi"
          :multi="message.content.multi"
        ></multi>
        
        <!--</div>-->
      </div>
    </transition>
  </div>
</template>

<script>
import MyCarousel from "./MyCarousel";
import TypingIndicator from "./TypingIndicator";
import Grid from "./Grid";
import Brands from "./Brands";
import Look from './Look'
import ProductCard from "./ProductCard";
import BoxSearch from './Box-search.vue';
import BoxEmailMessage from './Box-email-message.vue';
import BoxEmailFirstname from "./Box-email-firstname.vue";
import chatForm from "@/components/ChatForm";
import BoxPhone from './Box-phone.vue';
import MessageChecker from './MessageChecker.vue';
import Accordion from './Accordion.vue';
import Rating from './Rating.vue';
import RelativeTime from './RelativeTime.vue';
import AgentAssign from "./AgentAssign";
import Selection from './Selection';
import QcmQuestions from "./QcmQuestions.vue";
import { customLogger } from "@/utils";
import AudioPlay from "@/components/customs/Audio_play.vue";
import Multi from './Multi';



import specs from "@/specs";
import utils from '../utils';

export default {
  name: "Message",
  components: {
    chatForm,
    MyCarousel,
    TypingIndicator,
    Grid,
    Brands,
    Look,
    ProductCard,
    BoxSearch,
    BoxEmailMessage,
    BoxPhone,
    Rating,
    BoxPhone,
    Accordion,
    MessageChecker,
    RelativeTime,
    BoxEmailFirstname,
    AgentAssign,
    Selection,
    QcmQuestions,
    AudioPlay,
    Multi
  },
  props: {
    message: {
      type: Object,
      default: () => {},
    },
    mkey: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      box_email: false,
      box_email_message: false,
      box_search: false,
      bot_avatar: specs._IMG_AVATAR,
      admin_avatar: specs._ADMIN_IMG_AVATAR,
      cleanText: null
    };
  },
  computed: {
    text() {
      try{
        var text = typeof this.message?.content === "object" ? this.message?.content?.message : this.message?.content
        if (text == "popup.start_notreact"){ // Message de base
          if (this.$store.state.config.chat_config.chat_state.state == 'active'){ // Si le mode est 'Disponible'
            text = "popup.start"
          } else if (this.$store.state.config.chat_config.chat_state.state == 'no-active'){ // Si le mode est 'Indisponible'
            text = "popup.start_inact"
          } else if (this.$store.state.config.chat_config.chat_state.state == 'not_reactive') { // Si le mode est 'Non réactif'
            text = "popup.start_notreact"
          }
        }

        if (this.message.from_slack){
          text = utils.MarkdownKeyToHTML(text);
        }
        
        if (text){
          text = utils.convertToClickableLinks(text);
        }
        
        if(Array.isArray(text)) {
          customLogger("text is aray ?")
          text.map(t => {
            t = this.$i18n.t(t).trim()
            //t = utils.convert_textlinks_to_links(t)
          })
        }
        else {
          text = this.$i18n.t(text).trim()
          //text = utils.convert_textlinks_to_links(text)
        }
        return text
      }catch(e){
        customLogger("error", this.message)
      }
      
    },
  },
  mounted() {
    //#region agent_assign
    /**
     * remove the entrie message if the type is "agent_assign"
     * because it's used only on the admin side
     * @param {
     *  type: "agent_assign",
        agent: ......,
        user: ......,
        conversation_id: ......,
        sender_type: "admin",
        context: "chat",
        message: `Agent assined .....`, // <== removed this one
     * }
     */
    if (this.message?.content?.type === "agent_assign"){
      delete this.message.content.message
    }
    //#endregion

    if (this.$store.state.user.style_profile_key === 'box_email_message') {
      this.box_email_message = true
    }
    if (this.$store.state.user.style_profile_key === 'box_search') {
      this.box_search = true
    }
    if (this.message?.typing_indicator) {
      setTimeout(() => {
        delete this.message.typing_indicator;
        this.$forceUpdate();
        utils.scrollDown()
      }, 1000);
    }
  },
  methods:{
    ratingLike () {
      try {
        this.$store.dispatch("RATING_FEEDBACK", { feedback: "thumb_up", feedback_categorie: this.message?.content?.feedbackCategorie })
        this.message.content.ai_generated = false
      }
      catch(e){
        customLogger("error rating", e)
      }
    },
    async ratingDislike () {
      try {
        await this.$store.dispatch("RATING_FEEDBACK", { feedback: "thumb_down", feedback_categorie: this.message?.content?.feedbackCategorie })
        this.message.content.ai_generated = false
      }
      catch(e){
        customLogger("error rating", e)
      }
    },
    XssClean(text){
      this.cleanText = utils.CleanTextReceived(text)
      return this.cleanText
    }
  }
};
</script>
